module.exports = __webpack_public_path__ + "img/vp04.f1295033.jpg";